import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { forumApi } from '../services/api';

function Forum() {
  const [activeCategory, setActiveCategory] = useState('all');
  const [categories, setCategories] = useState([
    { id: 'all', name: '全部', count: 0 },
    { id: 'market', name: '市场分析', count: 0 },
    { id: 'strategy', name: '交易策略', count: 0 },
    { id: 'news', name: '新闻资讯', count: 0 }
  ]);
  const [forumPosts, setForumPosts] = useState([]);
  const [filteredPosts, setFilteredPosts] = useState([]);
  const [topUsers, setTopUsers] = useState([
    { id: 1, username: '投资达人', avatar: '', postCount: 120 },
    { id: 2, username: '股市分析师', avatar: '', postCount: 98 },
    { id: 3, username: '价值投资者', avatar: '', postCount: 85 }
  ]);
  const [searchInput, setSearchInput] = useState('');
  const [loading, setLoading] = useState(true);
  const [forumStats, setForumStats] = useState({
    totalTopics: 0,
    totalReplies: 0,
    totalMembers: 0,
    todayPosts: 0
  });
  
  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        // 获取热门话题
        const topicsResponse = await forumApi.getHotTopics();
        if (topicsResponse && topicsResponse.success && Array.isArray(topicsResponse.data)) {
          setForumPosts(topicsResponse.data);
          setFilteredPosts(topicsResponse.data);
          
          // 计算论坛统计数据
          setForumStats({
            totalTopics: topicsResponse.data.length * 10, // 模拟数据，实际应从API获取
            totalReplies: topicsResponse.data.reduce((sum, post) => sum + (post.replies || 0), 0) * 15,
            totalMembers: 3752,
            todayPosts: 42
          });
        } else {
          // 设置默认的帖子数据
          const defaultPosts = [
            {
              id: 1,
              title: '如何分析市场趋势？',
              author: '投资达人',
              date: '2025-03-20',
              replies: 15,
              views: 230,
              tags: ['market', 'analysis']
            },
            {
              id: 2,
              title: '分享我的价值投资策略',
              author: '价值投资者',
              date: '2025-03-18',
              replies: 28,
              views: 342,
              tags: ['strategy', 'value']
            },
            {
              id: 3,
              title: '近期市场波动分析',
              author: '股市分析师',
              date: '2025-03-15',
              replies: 42,
              views: 567,
              tags: ['market', 'news']
            }
          ];
          setForumPosts(defaultPosts);
          setFilteredPosts(defaultPosts);
          
          // 设置默认统计数据
          setForumStats({
            totalTopics: 324,
            totalReplies: 1865,
            totalMembers: 3752,
            todayPosts: 42
          });
        }

        // 获取论坛分类
        const categoriesResponse = await forumApi.getForumCategories();
        if (categoriesResponse && categoriesResponse.success && Array.isArray(categoriesResponse.data) && categoriesResponse.data.length > 0) {
          setCategories([
            { id: 'all', name: '全部', count: categoriesResponse.data.reduce((sum, cat) => sum + (cat.count || 0), 0) },
            ...categoriesResponse.data
          ]);
        }

        // 获取活跃用户
        const usersResponse = await forumApi.getActiveUsers();
        if (usersResponse && usersResponse.success && Array.isArray(usersResponse.data) && usersResponse.data.length > 0) {
          setTopUsers(usersResponse.data);
        }
      } catch (error) {
        console.error('获取论坛数据失败:', error);
        // 出错时不改变默认数据，确保UI仍然有内容显示
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  useEffect(() => {
    // 根据当前选中分类筛选帖子
    if (activeCategory === 'all') {
      setFilteredPosts(forumPosts);
    } else {
      setFilteredPosts(forumPosts.filter(post => post.tags && Array.isArray(post.tags) && post.tags.includes(activeCategory)));
    }
  }, [activeCategory, forumPosts]);

  const handleCategoryChange = (categoryId) => {
    setActiveCategory(categoryId);
  };

  const handleSearch = async () => {
    if (!searchInput.trim()) {
      // 如果搜索框为空，恢复显示所有帖子
      if (activeCategory === 'all') {
        setFilteredPosts(forumPosts);
      } else {
        setFilteredPosts(forumPosts.filter(post => post.tags && Array.isArray(post.tags) && post.tags.includes(activeCategory)));
      }
      return;
    }
    
    setLoading(true);
    try {
      const response = await forumApi.searchPosts(searchInput);
      if (response && response.success && Array.isArray(response.data)) {
        setFilteredPosts(response.data);
      } else {
        // 如果搜索失败或返回空结果，显示一个友好的消息
        setFilteredPosts([]);
      }
    } catch (error) {
      console.error('搜索帖子失败:', error);
      // 搜索失败时，保持当前显示的帖子不变
      if (activeCategory === 'all') {
        setFilteredPosts(forumPosts);
      } else {
        setFilteredPosts(forumPosts.filter(post => post.tags && Array.isArray(post.tags) && post.tags.includes(activeCategory)));
      }
    } finally {
      setLoading(false);
    }
  };

  if (loading && forumPosts.length === 0) {
    return (
      <div className="container">
        <div className="loading-spinner">加载中...</div>
      </div>
    );
  }

  return (
    <div className="container">
      {/* 面包屑导航 */}
      <div className="breadcrumbs">
        <Link to="/">首页</Link> <span>&gt;</span> <span>交流论坛</span>
      </div>

      <div style={{ display: 'flex', gap: '20px', flexWrap: 'wrap' }}>
        {/* 主内容区 */}
        <div style={{ flex: '1', minWidth: '300px' }}>
          {/* 论坛操作区 */}
          <div style={{ 
            display: 'flex', 
            justifyContent: 'space-between', 
            marginBottom: '20px', 
            alignItems: 'center' 
          }}>
            <div className="stock-search" style={{ maxWidth: '400px', marginBottom: '0' }}>
              <input 
                type="text" 
                placeholder="搜索帖子关键词" 
                value={searchInput}
                onChange={(e) => setSearchInput(e.target.value)}
              />
              <button onClick={handleSearch}>搜索</button>
            </div>
            <button style={{ 
              backgroundColor: '#ff7e31', 
              color: 'white', 
              border: 'none', 
              padding: '10px 20px', 
              borderRadius: '4px', 
              cursor: 'pointer',
              fontWeight: '500'
            }}>
              发布新帖
            </button>
          </div>
          
          {/* 分类区 */}
          <div className="section-card" style={{ marginBottom: '20px' }}>
            <div className="section-header">版块分类</div>
            <div className="section-content">
              <div style={{ display: 'flex', flexWrap: 'wrap', gap: '10px' }}>
                {categories.map(category => (
                  <button 
                    key={category.id}
                    onClick={() => handleCategoryChange(category.id)}
                    style={{
                      padding: '8px 15px',
                      borderRadius: '20px',
                      border: 'none',
                      backgroundColor: activeCategory === category.id ? '#1e3a8a' : '#eef3fd',
                      color: activeCategory === category.id ? 'white' : '#1e3a8a',
                      cursor: 'pointer',
                      fontSize: '14px',
                      fontWeight: '500'
                    }}
                  >
                    {category.name} ({category.count})
                  </button>
                ))}
              </div>
            </div>
          </div>
          
          {/* 帖子列表 */}
          <div className="section-card">
            <div className="section-header">
              {categories.find(c => c.id === activeCategory)?.name || '全部'} 话题
            </div>
            <div className="section-content" style={{ padding: '0' }}>
              {loading ? (
                <div className="loading-spinner" style={{ padding: '20px', textAlign: 'center' }}>加载中...</div>
              ) : filteredPosts.length > 0 ? (
                <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                  <thead>
                    <tr style={{ backgroundColor: '#f8f9fa', borderBottom: '1px solid #e1e4e8' }}>
                      <th style={{ padding: '12px 15px', textAlign: 'left', fontWeight: '500' }}>标题</th>
                      <th style={{ padding: '12px 15px', textAlign: 'center', fontWeight: '500', width: '100px' }}>作者</th>
                      <th style={{ padding: '12px 15px', textAlign: 'center', fontWeight: '500', width: '70px' }}>回复</th>
                      <th style={{ padding: '12px 15px', textAlign: 'center', fontWeight: '500', width: '70px' }}>查看</th>
                      <th style={{ padding: '12px 15px', textAlign: 'center', fontWeight: '500', width: '150px' }}>最后回复</th>
                    </tr>
                  </thead>
                  <tbody>
                    {filteredPosts.map(post => (
                      <tr key={post.id} style={{ borderBottom: '1px solid #e1e4e8' }}>
                        <td style={{ padding: '15px', verticalAlign: 'middle' }}>
                          <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                            {post.isTop && (
                              <span style={{ 
                                backgroundColor: '#e74c3c', 
                                color: 'white', 
                                fontSize: '12px', 
                                padding: '2px 6px', 
                                borderRadius: '4px' 
                              }}>
                                置顶
                              </span>
                            )}
                            {post.likes > 20 && (
                              <span style={{ 
                                backgroundColor: '#f39c12', 
                                color: 'white', 
                                fontSize: '12px', 
                                padding: '2px 6px', 
                                borderRadius: '4px' 
                              }}>
                                热门
                              </span>
                            )}
                            <Link to={`/forum/post/${post.id}`} style={{ color: '#333', textDecoration: 'none' }}>
                              {post.title}
                            </Link>
                          </div>
                        </td>
                        <td style={{ padding: '15px', textAlign: 'center', color: '#666', fontSize: '14px' }}>
                          {post.author}
                        </td>
                        <td style={{ padding: '15px', textAlign: 'center', color: '#666', fontSize: '14px' }}>
                          {post.replies}
                        </td>
                        <td style={{ padding: '15px', textAlign: 'center', color: '#666', fontSize: '14px' }}>
                          {post.views}
                        </td>
                        <td style={{ padding: '15px', textAlign: 'center', color: '#666', fontSize: '14px' }}>
                          {post.lastReply}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              ) : (
                <div style={{ padding: '20px', textAlign: 'center' }}>
                  没有找到相关帖子
                </div>
              )}
            </div>
          </div>
          
          {/* 分页 */}
          <div className="pagination" style={{ marginTop: '20px' }}>
            <div>共 {forumStats.totalTopics} 个主题</div>
            <div className="page-controls">
              <button>上一页</button>
              <button className="active">1</button>
              <button>2</button>
              <button>3</button>
              <button>下一页</button>
            </div>
          </div>
        </div>
        
        {/* 侧边栏 */}
        <div style={{ width: '280px' }}>
          {/* 论坛公告 */}
          <div className="section-card">
            <div className="section-header" style={{ fontSize: '16px' }}>论坛公告</div>
            <div className="section-content">
              <div style={{ padding: '10px 0', borderBottom: '1px solid #e1e4e8' }}>
                <Link to="#" style={{ color: '#1e3a8a', textDecoration: 'none', fontSize: '14px' }}>
                  论坛规则与发帖指南（必读）
                </Link>
              </div>
              <div style={{ padding: '10px 0', borderBottom: '1px solid #e1e4e8' }}>
                <Link to="#" style={{ color: '#1e3a8a', textDecoration: 'none', fontSize: '14px' }}>
                  3月18日系统维护通知
                </Link>
              </div>
              <div style={{ padding: '10px 0' }}>
                <Link to="#" style={{ color: '#1e3a8a', textDecoration: 'none', fontSize: '14px' }}>
                  优质内容创作激励计划
                </Link>
              </div>
            </div>
          </div>
          
          {/* 活跃用户 */}
          <div className="section-card" style={{ marginTop: '20px' }}>
            <div className="section-header" style={{ fontSize: '16px' }}>活跃用户</div>
            <div className="section-content">
              {topUsers.map((user, index) => (
                <div key={user.id} style={{ 
                  display: 'flex', 
                  alignItems: 'center', 
                  justifyContent: 'space-between',
                  padding: '10px 0',
                  borderBottom: index < topUsers.length - 1 ? '1px solid #e1e4e8' : 'none'
                }}>
                  <div style={{ display: 'flex', alignItems: 'center' }}>
                    <div style={{ 
                      width: '24px', 
                      height: '24px', 
                      backgroundColor: '#1e3a8a', 
                      color: 'white', 
                      borderRadius: '50%', 
                      display: 'flex', 
                      alignItems: 'center', 
                      justifyContent: 'center',
                      marginRight: '10px',
                      fontSize: '12px',
                      fontWeight: 'bold'
                    }}>
                      {index + 1}
                    </div>
                    <Link to="#" style={{ color: '#333', textDecoration: 'none', fontSize: '14px' }}>
                      {user.username}
                    </Link>
                  </div>
                  <div style={{ color: '#666', fontSize: '12px' }}>
                    发帖 {user.postCount}
                  </div>
                </div>
              ))}
            </div>
          </div>
          
          {/* 论坛数据 */}
          <div className="section-card" style={{ marginTop: '20px' }}>
            <div className="section-header" style={{ fontSize: '16px' }}>论坛数据</div>
            <div className="section-content">
              <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '10px' }}>
                <span style={{ color: '#666', fontSize: '14px' }}>总主题数:</span>
                <span style={{ fontWeight: '500', fontSize: '14px' }}>{forumStats.totalTopics.toLocaleString()}</span>
              </div>
              <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '10px' }}>
                <span style={{ color: '#666', fontSize: '14px' }}>总回复数:</span>
                <span style={{ fontWeight: '500', fontSize: '14px' }}>{forumStats.totalReplies.toLocaleString()}</span>
              </div>
              <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '10px' }}>
                <span style={{ color: '#666', fontSize: '14px' }}>注册会员:</span>
                <span style={{ fontWeight: '500', fontSize: '14px' }}>{forumStats.totalMembers.toLocaleString()}</span>
              </div>
              <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                <span style={{ color: '#666', fontSize: '14px' }}>今日发帖:</span>
                <span style={{ fontWeight: '500', fontSize: '14px' }}>{forumStats.todayPosts}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Forum;
